export default class productEnum {
    static MATHLETICS = { id: 1, name: 'Mathletics' };
    static SPELLODROME = { id: 3, name: 'Spellodrome' };
    static INTOSICENCE = { id: 6, name: 'Intoscience' };
    static PHONICS = { id: 8, name: 'Phonics' };
    static MATLETICA = { id: 9, name: 'Mathletics Play' };
    static READIWRITERSPELLING = { id: 10, name: 'Readiwriter Spelling' };
    static READIWRITERWRITING = { id: 11, name: 'Readiwriter Writing' };
}



// WEBPACK FOOTER //
// ./app/helpers/product-enum.js